import * as globals from '@wandb/weave/common/css/globals.styles';
import {assertUnreachable} from '@wandb/weave/common/util/types';
import React from 'react';

import EntityRegistryAccessControlsPage from '../../pages/EntityRegistryAccessControlsPage';
import {NoAccessPage} from '../../pages/NoAccessPage';
import {ModelRegistryPage} from '../ModelRegistry/ModelRegistryPage';
// @todo: Migrate to 'SkipToContent' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Content} from '../PageWithSidebar/PageWithSidebar.styles';
import {PanelArtifactDetailView} from '../panels.domain/artifact/PanelArtifactDetailView';
import {EntryPoint} from '../Registries/ModelRegistryMigration/utils';
import {RegistriesSearchContextProvider} from './common/RegistriesSearchContextProvider';
import {StarredRegistriesContextProvider} from './common/StarredRegistriesContextProvider';
import {ModelRegistryMigrationContextProvider} from './ModelRegistryMigration/ModelRegistryMigrationContextProvider';
import {RegistriesHomepage} from './RegistriesHomepage/RegistriesHomepage';

type RegistriesContentProps =
  | {
      type: 'load';
      componentName: 'PanelArtifactDetailView';
      props: {registryName: string};
    }
  | {
      type: 'load';
      componentName: 'RegistriesHomepage';
      props: {registryName?: string; loadSettingsPage: boolean};
    }
  | {
      type: 'load';
      componentName: 'EntityRegistryAccessControlsPage';
      props: {entityName: string};
    }
  | {type: 'load'; componentName: 'ModelRegistryPage'}
  | {
      type: 'load';
      componentName: 'NoAccessPage';
      props: {contentKey: 'noModelsAccess'};
    };

export const RegistriesContent: React.FC<
  RegistriesContentProps
> = registryAction => {
  // For all components except PanelArtifactDetailView, we render
  // with the HomePage's Content styled component
  switch (registryAction.componentName) {
    case 'PanelArtifactDetailView':
      return <PanelArtifactDetailView {...registryAction.props} />;
    case 'RegistriesHomepage':
      return (
        <Content background={globals.MOON_50}>
          <RegistriesSearchContextProvider>
            <StarredRegistriesContextProvider>
              <RegistriesHomepage {...registryAction.props} />
            </StarredRegistriesContextProvider>
          </RegistriesSearchContextProvider>
        </Content>
      );
    case 'ModelRegistryPage':
      return (
        <Content background={globals.MOON_50}>
          <ModelRegistryPage />
        </Content>
      );
    case 'EntityRegistryAccessControlsPage':
      return (
        <Content background={globals.MOON_50}>
          <ModelRegistryMigrationContextProvider
            entryPoint={EntryPoint.LEGACY_MR_ACCESS_CONTROLS}
            mrEntityName={registryAction.props.entityName}>
            <EntityRegistryAccessControlsPage {...registryAction.props} />
          </ModelRegistryMigrationContextProvider>
        </Content>
      );
    case 'NoAccessPage':
      return <NoAccessPage {...registryAction.props} />;
    default:
      return assertUnreachable(registryAction);
  }
};
export default RegistriesContent;
